import basicTheme from '../basicTheme.js';

const snackbarStyleOverride = {
    defaultProps: {},
    styleOverrides: {
        root: {
            display: 'flex',
            border: `1px solid ${basicTheme.palette.N50.main}`,
            borderRadius: '12px',
            backgroundColor: basicTheme.palette.N95.main,
            boxShadow: `0px 4px 32px ${basicTheme.palette.dropShadow}`,
            width: '296px',
            maxHeight: '136px',
            height: 'fit-content',
        },
    },
};

export { snackbarStyleOverride as default };
//# sourceMappingURL=MuiSnackbar.js.map
